<template>
  <!-- all-view :: swiper-options -->
  <div class="quick-menu-container is-wonju">
    <div class="quick-menu">
      <div class="quick-top-list">
        <!-- 수리과학정보 체험센터 -->
        <div class="link" @click="goMath">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/icon_math.png" alt="수리과학정보 새창 이동"/>
          </div>
          <p>수리과학정보<br>체험센터</p>
        </div>
        <!-- 강원메타버스 교육체험관 -->
        <div class="link" @click="goMetaverse">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/icon_metaverse.svg" alt="강원메타버스 교육체험관 새창 이동"/>
          </div>
          <p>강원메타버스<br>교육체험관</p>
        </div>
        <!-- GW 노트 -->
        <div class="link" @click="goGwNote">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/icon_note.png" alt="GW노트 새창 이동"/>
          </div>
          <p>GW노트+</p>
        </div>
        <!-- 온라인 참가신청 -->
        <div class="link" @click="goRequest">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/icon_request.png" alt="온라인참가신청 새창 이동"/>
          </div>
          <p>온라인 참가신청</p>
        </div>
        <!-- 강원보결전담강사 예약 -->
        <div class="link" @click="goProTutor">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/icon_vacancy.png" alt="보결전담강사 새창 이동"/>
          </div>
          <p>강원보결<br>전담강사예약</p>
        </div>
      </div>
      <div class="quick-bottom-list">
        <!-- url 단축 -->
        <div class="link" @click="goShortUrl">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/renewal/icon_url.svg" alt="url 새창 이동"/>
          </div>
          <p>단축 URL<br>만들기</p>
        </div>
        <!-- 전자책 출판 -->
        <div class="link" @click="goEBook">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/icon_eBook.png" alt="전자책 새창 이동"/>
          </div>
          <p>전자책 출판</p>
        </div>
        <!-- 설문 -->
        <div class="link" @click="goLanding( survey )">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/renewal/icon_surveyAll.png" alt="설문 랜딩페이지 새창 이동"/>
          </div>
          <p>설문</p>
        </div>
        <!-- 온라인 심사 -->
        <div class="link" @click="goContest">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/icon_contest.png" alt="온라인심사 새창 이동"/>
          </div>
          <p>온라인심사</p>
        </div>
        <!-- 통계분석 유레카 -->
        <div class="link eureka" @click="goEureka">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/icon_eureka.png" alt="통계분석 유레카 새창 이동"/>
          </div>
          <p>통계분석<br>유레카</p>
        </div>
        <!-- 학교통합누리집 지원센터 -->
        <div class="link" @click="goSchoolIntegration">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/icon_integration.png" alt="학교통합누리집 지원센터 새창 이동"/>
          </div>
          <p>학교통합누리집<br>지원센터</p>
        </div>
        <!-- 에듀테크 소개 -->
        <div class="link" @click="goToEduTech">
          <div class="link-image">
            <img src="@/assets/images/portal/icon/main/icon_edu_tech.png" alt="에듀테크 소개"/>
          </div>
          <p>에듀테크<br>소개</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import Cookies from "js-cookie";

const URL_NOTE = process.env.SYSTEM.NOTE.URL;
const URL_MATH = process.env.SYSTEM.MATH.URL;
const URL_PROTUTOR = process.env.SYSTEM.PROTUTOR.URL;
const URL_APPLY = process.env.SYSTEM.APPLY.URL;
const URL_CONTEST = process.env.SYSTEM.CONTEST.URL;
const URL_EBOOK = process.env.SYSTEM.EBOOK.URL;
const URL_SHORTURL = process.env.SYSTEM.SHORT_URL.URL;

const SURVEY = "survey";
const GANGWON = "gangwon";
const EUREKA = "eureka";

export default {
    name : "TheQuickWonjuMenu",
    data() {
        return {
            survey  : SURVEY,
            gangwon : GANGWON,
        }
    },
    computed : {
        ...mapGetters( {
            loginUser : "common/login/loginUserInfo",
        } ),

        swiper() {
            return this.$refs.quickMenuSwiper.swiper;
        },

        // 로그인이 되어 있는지 여부
        isLoggedIn() {
          return this.$validate.isNotEmpty( this.loginUser.userOid )
        },

        // 관리자면 true
        isAdmin() {
          return this.$constant.USER_TYPE.ADMIN.KEY === this.loginUser.userType;
        },

        // 학생이면 true
        isStudent() {
          return this.$constant.USER_TYPE.STUDENT.KEY === this.loginUser.userType || this.isAdmin;
        },

        // 강원교직원이면 true
        isGangWonStaff() {
          return this.$constant.USER_TYPE.STAFF_GANGWON.KEY === this.loginUser.userType || this.isAdmin;
        },

        // 일반교직원이면 true
        isStaff() {
          return this.$constant.USER_TYPE.STAFF.KEY === this.loginUser.userType || this.isAdmin;
        },


    },
    watch    : {},
    mounted() {
        // this.swiper.slideTo( 3, 1000, false );
    },
    methods : {
        goMath() {
            window.open( URL_MATH + "/math/sso/sso_login/" );
        },

        goMetaverse() {
          window.open( "https://www.wecanverse.co.kr/gwe_metaverse/" )
        },

        goGwNote() {

          // 로그인이 되어 있고 강원 교직원이 아닐 경우
          if ( this.isLoggedIn && !this.isGangWonStaff ) {
            this.$util.rsAlertUtils.rsAlert( { title : "강원 교직원 회원만 이용이 가능합니다.", contents : "", state : "warning" } );
            return;
          }

          // SSO_MODE 가 아닐 경우 sso_login로 이동
          if ( !this.$constant.SSO_MODE ) {
            window.open( URL_NOTE + "/note/sso/sso_login" );
            return;
          }

          // SSO_MODE 일 경우
          // 로그인이 안되어 있을 경우
          if ( !this.isLoggedIn ) {
            window.open( `${process.env.SYSTEM.ACCOUNTS.URL}/v1/login/login?sys=note&eox=${URL_NOTE}` );
          }
          // 노트 메인 화면으로 이동
          else {
            window.open( URL_NOTE + "/gwnote/main/userMain" );
          }
        },

        async goContest() {
            window.open( URL_CONTEST )
        },

        goRequest() {
            window.open( URL_APPLY + "/apply/sso/sso_login" )
        },

        goProTutor() {
            window.open( URL_PROTUTOR )
        },

        goShortUrl() {

            // 쿠키 KWE_USERID, KWE_LOGIN_TYPE을 얻어와 단축 url SLO 처리를 합니다.
            const KWE_USERID = Cookies.get( "KWE_USERID" );
            const KWE_LOGIN_TYPE = Cookies.get( "KWE_LOGIN_TYPE" );

            if ( this.$validate.isEmpty( KWE_USERID ) ) {
                window.open( URL_SHORTURL );
                return;
            }

            const loginType = this.$validate.isNotEmpty( KWE_LOGIN_TYPE ) ? KWE_LOGIN_TYPE : "";
            let userId = "";

            // KWE_USERID 쿠키가 있을 경우
            if ( KWE_USERID ) {
                // 암호화 후 URL인코딩 진행
                const encryptUserId = this.$util.encryptUtils.encryptAesValue( KWE_USERID );
                userId = encodeURIComponent( encryptUserId );
            }

            window.open( URL_SHORTURL + `/shorturl/sso/sso_login_eow?EOW=${userId}&QIB=${loginType}` );
        },

        goEBook() {

          // 로그인이 되어 있고 교직원이 아닐 경우
          if ( this.isLoggedIn && !( this.isGangWonStaff || this.isStaff ) ) {
            this.$util.rsAlertUtils.rsAlert( { title : "교직원 회원만 이용이 가능합니다.", contents : "", state : "warning" } );
            return;
          }

          // SSO_MODE가 아닐 경우
          if ( !this.$constant.SSO_MODE ) {
            window.open( URL_EBOOK );
            return;
          }

          // SSO_MODE일 경우
          // 로그인하지 않았을 경우 accounts 로 이동
          if ( !this.isLoggedIn ) {
            window.open( `${process.env.SYSTEM.ACCOUNTS.URL}/v1/login/login?sys=ebook&eox=${URL_EBOOK}` );
          }
          // 노트 메인 화면으로 이동
          else {
            window.open( URL_EBOOK );
          }
        },

        // 설문, 강원 관련 랜딩페이지
        goLanding( type ) {

            const origin = window.location.origin;
            let url = `${origin}/portal/user/landing/user_landing`;

            if ( this.survey === type ) {
                url += `?survey=${this.$constant.FLAG_YN.YES}`;
            }
            else if ( this.gangwon === type ) {
                url += `?gangwon=${this.$constant.FLAG_YN.YES}`;
            }
            else if ( EUREKA === type ) {
                url += `?eureka=${this.$constant.FLAG_YN.YES}`;
            }
            // 설문 혹은 강원 타입이 아닐 경우 새 창 오픈하지 않음
            else {
                return;
            }

            window.open( url );

        },

        goSchoolIntegration() {
            window.open( "https://helpschool.gwe.go.kr/" );
        },

        // 유레카
        goEureka() {

            // 로그인 하지 않았을 경우 랜딩 페이지 오픈 -> 학생/교직원 선택
            // 교직원 선택 시 로그인 창으로 유도
            // 학생일 경우 로그인되지 않은 유레카 페이지로 이동
            if ( this.$validate.isEmpty( this.loginUser )
                || this.$validate.isEmpty( this.loginUser.userOid ) ) {

                this.goLanding( EUREKA );
                return;
            }

            // 로그인 & 교직원이거나 관리자 권한이 있을 경우
            // 로그인된 유레카 페이지로 이동
            if ( this.$constant.USER_TYPE.STAFF_GANGWON.KEY === this.loginUser.userType
                || this.loginUser.isManager ) {

                window.open( "https://www.statschool.net/commonstat.do?method=memid_autologin&usr_id=gwedu" );
                return;
            }
            // 로그인 & 교직원이 아닐 경우 로그인되지 않은 유레카 페이지로 이동
            window.open( "https://www.statschool.net/main.do" );
        },

        goToEduTech() {
            const routePath = this.$router.resolve( "/portal/user/eduTech/edu_tech" ).href;
            window.open( routePath, "_blank" );
        }
    },
}
</script>
<style scoped>
</style>
